export const VARIANTS = Object.freeze({
  SOLID: 'solid',
  NAKED: 'naked',
  GHOST: 'ghost',
  LINK: 'link',
  ICON: 'icon',
})
